/**
 * Shared layout component with sidebar navigation.
 */
import React from 'react';
import { SidebarLayout } from './SidebarLayout';
import { Footer } from './Footer';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <SidebarLayout>
      <div className="layout-content">
        {children}
      </div>
      <Footer />
    </SidebarLayout>
  );
};

